import React from "react";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../CustomComponents/CustomCard/CustomCard";
import CustomCardContent from "../CustomComponents/CustomCardContent/CustomCardContent";
import CustomLink from "../CustomComponents/CustomLink/CustomLink";
import clsx from "clsx";
import { useStyles } from "../../assets/jss/Dashboard";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomBarChart from "../CustomComponents/CustomBarChart/CustomBarChart";
import { useTheme } from "@material-ui/core/styles";
import moment from "moment";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { getContentEngagementGraph } from "../../services/ContentEngagementGraph";
import { getSession, getUserRBAC } from "../../services/LocalStorageService";
import { EntityAccess, RBAC_CODE } from "../../config/app-globals.enum";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

export default function DashboardContentEngagementGraph(props:any) {
    const params = useParams();
    const { t } = useTranslation();
    const classes = useStyles();
    const theme = useTheme();
    // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [getRBAC_CE_View] = React.useState(getUserRBAC(RBAC_CODE.CE_VIEW, props));
    const [isApi, setIsApi] = React.useState(false);
    const [isApiFailed, setIsApiFailed] = React.useState(false);
    const [userSession] = React.useState(getSession);
    const [contentData, setContentData] = React.useState([]);
    const [contentEngagementBar, setContentEngagementBar] = React.useState<any>({});
    const [chartOptions] = React.useState({
        legend: { display: false },
        scales: {
            xAxes: [
                {
                    gridLines: {
                        color: "rgba(128, 151, 177, .08)",
                    },
                },
            ],
            yAxes: [
                {
                    ticks: { beginAtZero: true },
                    gridLines: {
                        color: "rgba(128, 151, 177, .08)",
                    },
                },
            ],
        },
    });

    //====
    const [statusValue, setStatusValue] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);
    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };
    //====
    React.useEffect(() => {
        if (userSession && (isApiFailed || (contentData && !contentData.length))) {
            const dateArray = [];
            const randomData = [];
            const randomData1 = [];
            let startdate = new Date(userSession.startDate);
            const enddate = new Date(userSession.endDate);
            while (startdate <= enddate) {
                dateArray.push(moment(startdate).format("DD MMM"));
                randomData.push(Math.random() * 100);
                randomData1.push(Math.random() * 100);
                startdate.setDate(startdate.getDate() + 1);
            }
            setContentEngagementBar({
                labels: dateArray,
                datasets: [
                    {
                        data: randomData,
                        backgroundColor: "rgb(241, 242, 246)",
                        borderColor: "rgb(241, 242, 246)",
                        borderWidth: 0,
                        barPercentage: 5,
                        borderSkipped: 0,
                        barThickness: 13,
                        maxBarThickness: 8,
                        label: t("ASSIGNED_CONTENT"),
                        minBarLength: 2,
                    },
                    {
                        data: randomData1,
                        backgroundColor: "rgb(241, 242, 246)",
                        borderColor: "rgb(241, 242, 246)",
                        borderWidth: 0,
                        barPercentage: 5,
                        borderSkipped: 0,
                        barThickness: 13,
                        maxBarThickness: 8,
                        label: t("ENGAGEMENT"),
                        minBarLength: 2,
                    },
                ],
            });
        }
    }, [userSession, isApiFailed, contentData]);

    React.useEffect(() => {
        async function getContentEngagementGraphData() {
            setIsApi(true);
            setStatusValue(null);
            setAlertMessage("");
            setIsAlertOpen(false);
            const data = await getContentEngagementGraph(params);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                setIsApi(false);
                if (data.content.length) {
                    data.content.sort(
                        (item1, item2) =>
                            new Date(item1.sentDate).getTime() - new Date(item2.sentDate).getTime()
                    );
                    setContentData(data.content);
                }
            } else {
                setIsApi(false);
                setIsApiFailed(true);
                changeApiStatusCodeFunc(data.status);
            }
        }
        getContentEngagementGraphData();
    }, []);

    React.useEffect(() => {
        if (contentData && contentData.length) {
            let labels = [];
            let sentCount = [];
            let completedCount = [];

            for (const [index, data] of contentData.entries()) {
                labels.push(moment(data.sentDate).format("DD MMM"));
                sentCount.push(data.sentCount);
                completedCount.push(data.completedCount);
            }
            setContentEngagementBar({
                labels: labels,
                datasets: [
                    {
                        data: sentCount,
                        backgroundColor: isApiFailed
                            ? "rgb(241, 242, 246)"
                            : "rgb(140, 84, 255)",
                        borderColor: isApiFailed
                            ? "rgb(241, 242, 246)"
                            : "rgb(140, 84, 255)",
                        borderWidth: 0,
                        barPercentage: 5,
                        borderSkipped: 0,
                        barThickness: 13,
                        maxBarThickness: 8,
                        label: t("ASSIGNED_CONTENT"),
                        minBarLength: 2,
                    },
                    {
                        data: completedCount,
                        backgroundColor: isApiFailed
                            ? "rgb(241, 242, 246)"
                            : "rgb(46,91,255)",
                        borderColor: isApiFailed ? "rgb(241, 242, 246)" : "rgb(46,91,255)",
                        borderWidth: 0,
                        barPercentage: 5,
                        borderSkipped: 0,
                        barThickness: 13,
                        maxBarThickness: 8,
                        label: t("ENGAGEMENT"),
                        minBarLength: 2,
                    },
                ],
            });
        }
    }, [contentData]);

    return (
        <>
            <CustomPaper
                square
                elevation={0}
                className={clsx(
                    classes.height100,
                    isApiFailed ? classes.graphDisabled : null
                )}
            >
                <CustomCard
                    elevation={0}
                    className={clsx(classes.height100, classes.cardContentWrapper)}
                >
                    <CustomCardContent className={classes.cardContent}>
                        <CustomGrid container spacing={0} justifyContent="space-between">
                            <CustomGrid item>
                                <CustomTypography
                                    className={classes.cardTitle}
                                    component="h3"
                                    variant="h3"
                                >
                                    {t("CONTENT_ENGAGEMENT_DETAILS")}
                                </CustomTypography>
                            </CustomGrid>
                            <CustomGrid item>
                                <CustomTypography
                                    className={classes.contentEngagementLegend}
                                    component="h3"
                                    variant="h3"
                                >
                                    <span
                                        className={clsx(
                                            !isApiFailed &&
                                            !isApi &&
                                            contentData.length &&
                                            classes.assignedContentBullet,
                                            classes.graphBullet
                                        )}
                                    ></span>
                                    {t("ASSIGNED_CONTENT")}
                                    <span
                                        className={clsx(
                                            !isApiFailed &&
                                            !isApi &&
                                            contentData.length &&
                                            classes.engagementContentBullet,
                                            classes.graphBullet
                                        )}
                                    ></span>
                                    {t("ENGAGEMENT")}
                                </CustomTypography>
                            </CustomGrid>
                        </CustomGrid>
                        <CustomGrid
                            className={classes.graphContainer}
                            container
                            alignItems="center"
                            justifyContent="center"
                            spacing={0}
                        >
                            <CustomGrid item xs={12}>
                                <CustomBox mt={3}>
                                    {isApi ? <CustomCircularProgress /> : null}
                                    {!isApi ? (
                                        <CustomBarChart
                                            data={contentEngagementBar}
                                            options={chartOptions}
                                            height={90}
                                        />
                                    ) : null}
                                </CustomBox>
                            </CustomGrid>
                        </CustomGrid>
                        <CustomGrid
                            container
                            // justifyContent={isMobile ? "center" : "flex-end"}
                            justifyContent={"flex-end"}
                            className={classes.justifyCenter}
                            spacing={0}
                        >
                            <CustomGrid item>
                                <CustomBox component="div" mt={2}>
                                    {getRBAC_CE_View &&
                                        getRBAC_CE_View.isAccessible ===
                                        EntityAccess.ALLOWED ? (
                                        <>
                                            {isApiFailed || isApi || !contentData.length ? (
                                                <CustomTypography
                                                    className={classes.viewDetailLinkDisabled}
                                                    component="span"
                                                >
                                                    {t("VIEW_DETAILS")}
                                                </CustomTypography>
                                            ) : (
                                                <CustomLink
                                                    className={classes.viewDetailLink}
                                                    href={params.impersonationid ? `/impersonation/${params.impersonationid}/engagement` : "/engagement"}
                                                >
                                                    {t("VIEW_DETAILS")}
                                                </CustomLink>
                                            )}
                                        </>
                                    ) : null}
                                </CustomBox>
                            </CustomGrid>
                        </CustomGrid>
                    </CustomCardContent>
                </CustomCard>
            </CustomPaper>
            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
        </>
    );
}
